import { DatePicker, Loader } from '@pukka/ui-components';
import { useSnapshot } from '@pukka/valtio';

import { DerivedState, DetailedOutlet, State } from './comparison.state';
import { GraphComparison } from './GraphComparison';
import IconOutletGroup from './ic-outlet-group.svg';
import { OutletComparisonSelector } from './OutletComparisonSelector';
import { TableSummary } from './TableSummary';

function outletMapper(id: number) {
  return State.outlets.get(id) as DetailedOutlet;
}

function renderBlocker(isFeatureAvailable: boolean) {
  return !isFeatureAvailable ? (
    <div data-testid="feature-overlay" className="absolute inset-0 z-10 h-full w-full bg-white/50 pt-[220px] text-center">
      <img src={IconOutletGroup} height={75} className="m-auto mb-4" alt="Feature is not available" />
      <div className="mb-2 font-bold">Feature is not available</div>
      <div className="text-sm">Outlet Comparison is available for Merchants with 2 outlets or more</div>
    </div>
  ) : null;
}

function ComparisonPage() {
  const { status, data } = State.useData();
  const { isFeatureAvailable, outlets, onRemove, onSetDate } = useSnapshot(State);
  const { count, startDate, endDate, selectedOutletIds, canAddMore, canRemove } = useSnapshot(DerivedState);

  const isOnlyTwoOutlets = data?.outlets?.length === 2;

  return status === 'loading' ? (
    <div className="flex h-80 flex-auto items-center justify-center">
      <Loader type="ellipsis" />
    </div>
  ) : (
    <div>
      <div className="mb-6 flex gap-3">
        <OutletComparisonSelector numberOfOutlets={count} disabled={!isFeatureAvailable || isOnlyTwoOutlets} />
        <DatePicker
          allDay
          rangePicker
          disabled={!isFeatureAvailable}
          startDate={startDate}
          endDate={endDate}
          dates={[null, new Date()]}
          onChangeDate={onSetDate}
        />
      </div>

      <div className="relative mb-20 md:mb-8">
        {renderBlocker(isFeatureAvailable)}

        <TableSummary
          isFeatureAvailable={isFeatureAvailable}
          canAddMore={canAddMore}
          canRemove={canRemove}
          outlets={outlets}
          selectedOutletIds={selectedOutletIds}
          onRemove={onRemove}
        />

        <GraphComparison data={selectedOutletIds.map(outletMapper)} isFeatureAvailable={isFeatureAvailable} />
      </div>
    </div>
  );
}

export { outletMapper as _outletMapper, renderBlocker as _renderBlocker };

export default ComparisonPage;
